import { Button } from "@mui/material";

import { useDisclosure } from "hooks";

import { AddShipmentTrackingLinkModal } from "../AddShipmentTrackingLinkModal";

interface Props {
  shipmentId: number;
  shipmentType: ShipmentType;
  onRefresh: () => void;
  buttonLabel: string;
  alertComponent?: JSX.Element | null;
}

export function AddShipmentTrackingLinkForm(props: Props) {
  const {
    shipmentId,
    shipmentType,
    onRefresh,
    buttonLabel,
    alertComponent = null,
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure(false);

  return (
    <>
      {alertComponent}
      <Button
        variant="contained"
        color="info"
        onClick={onOpen}
        sx={{ mt: "1rem", mb: "1rem" }}
      >
        {buttonLabel}
      </Button>
      <AddShipmentTrackingLinkModal
        isOpen={isOpen}
        onClose={onClose}
        shipmentId={shipmentId}
        shipmentType={shipmentType}
        onRefresh={onRefresh}
      />
    </>
  );
}
